import rules from "@/utils/inputRules";
import { isFalse, isTrue } from "@/utils/service/DocumentGeneration/answers";
import { translation } from "@/utils/service/Translations/translations";
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from "@/utils/service/documents";

export default [
    {
        name: "General Information",
        inputs: [
            {
                model: "company.name",
                type: "businessName",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                model: "company.email",
                type: "email",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                model: "company.address",
                type: "address",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                label: "Phone number",
                model: "company.phone",
                type: "phone",
                classes: "col-md-6",
                input: {
                    global: false,
                },
            },
        ],
        actions: [
            {
                component: () =>
                    import(
                        "@/components/Projects/Project/ProjectGeneralInformationUpdateOnDocumentCreate.vue"
                    ),
                params: (self) => ({
                    color: "secondaryDark",
                    text: true,
                    class: "th-mr-12",
                    to: {
                        name: "project_index",
                        params: self?.$route.params,
                    },
                }),
                cta: "Edit project information",
            },
        ],
    },
    {
        name: "Programinė įranga",
        inputs: [
            {
                label: "Koks Jūsų programinės įrangos pavadinimas?",
                model: "software_name",
                type: "text",
                rules: [rules.required],
            },
        ],
    },
    {
        name: "Licencijos davėjas",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    // title: "Useful information",
                    title:
                        'Šios sutarties tekste bus naudojamas sutrumpintas licencijos davėjo pavadinimas. Pvz. Jeigu jūsų įmonės pavadinimas yra UAB "Termshub Group Corporation", rekomenduojama įrašyti "Termshub" arba "TGC".',
                }),
            },
        ],
        inputs: [
            {
                label: "Kas yra licencijos davėjas?",
                model: "licensor",
                type: "text",
                rules: [rules.required],
            },
        ],
    },
    {
        name: "Privatumo politika",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    // title: "Useful information",
                    title:
                        "Bus laikoma, kad Jūs renkate asmens duomenis jeigu: Jūsų programinė įranga renka (pvz. naudojant slapukus) asmeninę informaciją apie Jūsų programinės įrangos vartotojus arba apie jų elgesį su programine įranga, taip pat jeigu Jūs prašote vartotojų užsiregistruoti arba pateikti tam tikrus asmens duomenis prieš atsiunčiant, išsaugant arba naudojant programinę įrangą ar tam tikras jos funkcijas.",
                }),
            },
        ],
        inputs: [
            {
                title:
                    "Ar jūsų programinė įranga renka arba saugo asmens duomenis (pvz. vardas, pavardė, IP adresas ir pan.)?",
                model: "privacyPolicy.use",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) => isTrue(model["privacyPolicy.use"]),
                title: "Please insert the link to your Privacy Policy",
                model: "privacyPolicy.link",
                rules: [rules.url],
                type: "text",
            },
            // {
            //     condition: (model) => isTrue(model["privacyPolicy.use"]),
            //     title: "Please insert the link to your Privacy Policy",
            //     model: "privacyPolicy.link",
            //     type: "projectDocument",
            //     policyType: PRIVACY_POLICY,
            // },
            // {
            //     condition: (model) => isFalse(model["privacyPolicy.use"]),
            //     type: "custom",
            //     component: () =>
            //         import("@/components/DocumentGeneration/Alert.vue"),
            //     input: {
            //         title: `Your Software may automatically collect personal information (e.g. by using cookies and web beacons) about your user's device and about the use of the Software. You also may require users to provide certain information as a condition to downloading, installing, or using the Software or certain of its features or functionality.`,
            //     },
            // },
            // {
            //     condition: (model) => isFalse(model["privacyPolicy.use"]),
            //     model: "privacyPolicy.no_use_create",
            //     type: "projectDocumentCreateSuggest",
            //     policyType: PRIVACY_POLICY,
            // },
        ],
        validate: (model) =>
            isFalse(model["privacyPolicy.use"]) ||
            rules.required(model["privacyPolicy.link"]) ||
            rules.url(model["privacyPolicy.link"]) ||
            true,
    },
    {
        name: "Atnaujinimai",
        inputs: [
            {
                title:
                    "Ar ketinate kurti ir teikti programinės įrangos atnaujinimus ir patobulinimus, kurie gali apimti klaidų taisymus, periodinę techninę priežiūrą ir/arba naujas funkcijas?",
                model: "updates",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Trečiųjų šalių turinys ",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    title:
                        "Bus laikoma, kad Jūsų programinėje įrangoje yra prieiga į trečiųjų šalių turinį jeigu: bus rodomas arba kitaip prieinamas trečiųjų šalių turinys (įskaitant duomenis, informaciją ir kitus produktus, paslaugas ir (arba) kitą medžiagą), taip pat pateikiamos nuorodos į trečiųjų šalių svetaines ar paslaugas, įskaitant trečiųjų šalių reklamą.",
                }),
            },
        ],
        inputs: [
            {
                title:
                    "Ar Jūsų programinėje įrangoje gali būti rodomas arba kitaip prieinamas trečiųjų šalių turinys?",
                model: "third_party_materials",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Vartotojo turinys",
        inputs: [
            {
                title:
                    "Ar jūsų vartotojas galės generuoti, sukurti, siųsti ar viešinti turinį Jūsų programinėje įrangoje arba per programinę įrangą?",
                model: "user_generated_content",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Vartotojo rekomendacijos",
        inputs: [
            {
                title:
                    "Ar jūsų vartotojas galės pateikti Jums nuomonę arba rekomendacijas apie Jūsų programinę įrangą ar jos funkcionalumą?",
                model: "users_feedback",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ],
    },
    {
        name: "Ginčų sprendimas",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    title:
                        "Įrašykite savo buveinės vietos šalį arba pasitarkite su teisininku, kurios šalies teisę Jums verta rinktis dėl palankesnių įstatymų.",
                }),
            },
        ],
        inputs: [
            {
                title:
                    "Pagal kurios šalies teisę bus sprendžiami ginčai, nesutarimai ir/ar reikalavimai, kylantys iš šios Licencijos sutarties ar susijęs su šia sutartimi?",
                model: "law_country",
                type: "country",
                input: {
                    global: false,
                },
            },
            {
                condition: (model) =>
                    model["law_country"] &&
                    model["law_country"] === "United States",
                model: "law_country_state",
                type: "state",
                input: (model) => ({
                    country: model["law_country"],
                    global: false,
                }),
            },
        ],
    },
];
